import { Injectable, inject } from '@angular/core';
import { ThemeLoaderService } from './theme-loader.service';
import { AppParamItems, AppParamsService } from '../app-params.service';
import { Theme, ThemeDefaults } from './theme';
import { BehaviorSubject, combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeManagerService {
  private readonly appParamService = inject(AppParamsService);
  private readonly themeLoaderService = inject(ThemeLoaderService);

  isLoaded = false;
  private readonly themeLoadedSubject = new BehaviorSubject<boolean>(this.isLoaded);

  onLoad() {
    return this.themeLoadedSubject.asObservable();
  }

  watchForUserPreferences() {
    const primaryColor$ = this.appParamService.watchFor(
      AppParamItems.AppParamMarketing.primaryColor
    );
    const secondaryColor$ = this.appParamService.watchFor(
      AppParamItems.AppParamMarketing.secondaryColor
    );
    const btnFontSize$ = this.appParamService.watchFor(
      AppParamItems.AppParamMarketing.buttonFontSize
    );
    const titleFontSize$ = this.appParamService.watchFor(
      AppParamItems.AppParamMarketing.titleFontSize
    );
    const infoPalelFontSize$ = this.appParamService.watchFor(
      AppParamItems.AppParamMarketing.infoPanelFontSize
    );
    const contentFontSize$ = this.appParamService.watchFor(
      AppParamItems.AppParamMarketing.contentFontSize
    );

    combineLatest([
      primaryColor$,
      secondaryColor$,
      btnFontSize$,
      titleFontSize$,
      infoPalelFontSize$,
      contentFontSize$,
    ]).subscribe((themeValues) => {
      const theme = Theme.toEntity({
        primaryColor: themeValues[0].hex
          ? `#${themeValues[0].hex}`
          : ThemeDefaults.PRIMARY_COLOR,
        secondaryColor: themeValues[1].hex
          ? `#${themeValues[1].hex}`
          : ThemeDefaults.SECONDARY_COLOR,
        btnFontSize: themeValues[2],
        titleFontSize: themeValues[3],
        infoPanelFontSize: themeValues[4],
        contentFontSize: themeValues[5],
      });
      this.themeLoaderService.setTheme(theme);

      setTimeout(() => {
        this.isLoaded = true;
        this.themeLoadedSubject.next(true);
      }, 200);
    });
  }
}
